import {Component, inject, signal} from '@angular/core';
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {GameService} from "../../../services/game.service";
import {ActiveUserService} from "../../../services/active-user.service";
import {IEditCharityRegistrationUrl} from "../../../interfaces/IEditCharityRegistrationUrl";
import {SnackbarService} from "../../../services/snackbar.service";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";

@Component({
  selector: 'app-edit-charity-registration-url',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatFormField,
    MatInput,
    MatLabel,
    MatError,
    ReactiveFormsModule,
    MatButton
  ],
  templateUrl: './edit-charity-registration-url.component.html',
  styleUrl: './edit-charity-registration-url.component.css'
})
export class EditCharityRegistrationUrlComponent {

  private dialogRef = inject(MatDialogRef<EditCharityRegistrationUrlComponent>);
  private gameService = inject(GameService);
  private activeUserService = inject(ActiveUserService);
  public game = inject<IGameQueryResult>(MAT_DIALOG_DATA);
  private snackBarService = inject(SnackbarService);

  public uiState = signal(UIStateEnum.ShowData);
  public uiStateEnumForTemplate = UIStateEnum;

  public urlControl = new FormControl<string | null>(this.game.CharityRegistrationUrl, [Validators.pattern(/^https:\/\/.+/)]);

  submit() {
    if (this.urlControl.errors) {
      this.urlControl.markAsTouched();
      return;
    }

    this.uiState.set(UIStateEnum.ShowLoading);

    let command: IEditCharityRegistrationUrl = {
      GameId: this.game.Id,
      AdminId: this.activeUserService.activeUser().Id,
      Url: this.urlControl.value || null,
    }

    this.gameService.updateCharityRegistrationUrl(command).subscribe({
      next: () => {
        this.uiState.set(UIStateEnum.ShowData);
        this.snackBarService.openSuccessfulSnackBar("Successfully updated charity registration URL");
        this.dialogRef.close(true);
      },
      error: () => {
        this.uiState.set(UIStateEnum.ShowData);
        this.snackBarService.openErrorSnackBar("Failed to update charity registration URL");
      }
    })
  }
}
